/**
 * @flow
 * @relayHash 5ec08291a7d1a46c9ce976f66fcc3652
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type srcAmpArticleQueryVariables = {||};
export type srcAmpArticleQueryResponse = {|
  +articles: $ReadOnlyArray<{|
    +publishedAt: ?string,
    +slug: ?string,
    +title: ?string,
    +forceTitleToAppearUnderneath: ?boolean,
    +caption: ?string,
    +readingTime: ?number,
    +picture: ?string,
    +widePicture: ?string,
    +videoLink: ?string,
    +author: ?{|
      +firstname: ?string,
      +lastname: ?string,
      +biography: ?string,
      +picture: ?string,
      +facebook: ?string,
      +twitter: ?string,
      +instagram: ?string,
      +website: ?string,
    |},
    +sponsor: ?{|
      +name: ?string,
      +description: ?string,
      +logo: ?string,
    |},
    +city: ?{|
      +slug: string,
      +name: string,
      +color: ?string,
      +articles: $ReadOnlyArray<{|
        +slug: ?string,
        +title: ?string,
        +caption: ?string,
        +readingTime: ?number,
        +picture: ?string,
        +author: ?{|
          +firstname: ?string,
          +lastname: ?string,
        |},
      |}>,
    |},
    +cities: ?$ReadOnlyArray<?{|
      +slug: string,
      +name: string,
      +color: ?string,
      +articles: $ReadOnlyArray<{|
        +slug: ?string,
        +title: ?string,
        +caption: ?string,
        +readingTime: ?number,
        +picture: ?string,
        +author: ?{|
          +firstname: ?string,
          +lastname: ?string,
        |},
      |}>,
    |}>,
    +category: ?{|
      +slug: ?string,
      +name: ?string,
      +color: ?string,
      +articles: $ReadOnlyArray<{|
        +slug: ?string,
        +title: ?string,
        +caption: ?string,
        +readingTime: ?number,
        +picture: ?string,
        +author: ?{|
          +firstname: ?string,
          +lastname: ?string,
        |},
      |}>,
    |},
    +slices: $ReadOnlyArray<{|
      +type: ?string,
      +intro: ?{|
        +initialLetter: ?string,
        +text: ?string,
      |},
      +pictureDuo: $ReadOnlyArray<{|
        +picture: ?string,
        +caption: ?string,
      |}>,
      +inlinePicture: ?{|
        +picture: ?string,
        +caption: ?string,
      |},
      +highlightedPicture: ?{|
        +picture: ?string,
        +caption: ?string,
      |},
      +quote: ?string,
      +embed: ?string,
      +paragraph: $ReadOnlyArray<{|
        +type: ?string,
        +text: ?string,
        +spans: ?$ReadOnlyArray<{|
          +start: number,
          +end: number,
          +type: string,
          +data: ?{|
            +id: ?string,
            +uid: ?string,
            +type: ?string,
            +slug: ?string,
            +link_type: ?string,
            +url: ?string,
          |},
        |}>,
      |}>,
      +textPicture: ?{|
        +picture: ?string,
        +content: ?$ReadOnlyArray<?{|
          +type: ?string,
          +text: ?string,
          +label: ?string,
          +spans: ?$ReadOnlyArray<{|
            +data: ?{|
              +id: ?string,
              +uid: ?string,
              +type: ?string,
              +slug: ?string,
              +url: ?string,
              +link_type: ?string,
            |},
            +start: number,
            +end: number,
            +type: string,
          |}>,
        |}>,
      |},
    |}>,
    +seo: ?{|
      +title: ?string,
      +description: ?string,
    |},
    +social: ?{|
      +twitter: ?$ReadOnlyArray<?{|
        +type: ?string,
        +title: ?string,
        +image: ?string,
        +handle: ?string,
        +description: ?string,
      |}>,
      +generic: ?$ReadOnlyArray<?{|
        +title: ?string,
        +image: ?string,
        +description: ?string,
      |}>,
    |},
  |}>
|};
export type srcAmpArticleQuery = {|
  variables: srcAmpArticleQueryVariables,
  response: srcAmpArticleQueryResponse,
|};
*/


/*
query srcAmpArticleQuery {
  articles(first: 10000) {
    publishedAt
    slug
    title
    forceTitleToAppearUnderneath
    caption
    readingTime
    picture
    widePicture
    videoLink
    author {
      firstname
      lastname
      biography
      picture
      facebook
      twitter
      instagram
      website
    }
    sponsor {
      name
      description
      logo
    }
    city {
      slug
      name
      color
      articles(first: 7) {
        slug
        title
        caption
        readingTime
        picture
        author {
          firstname
          lastname
        }
      }
    }
    cities {
      slug
      name
      color
      articles(first: 7) {
        slug
        title
        caption
        readingTime
        picture
        author {
          firstname
          lastname
        }
      }
    }
    category {
      slug
      name
      color
      articles(first: 7) {
        slug
        title
        caption
        readingTime
        picture
        author {
          firstname
          lastname
        }
      }
    }
    slices {
      type
      intro {
        initialLetter
        text
      }
      pictureDuo {
        picture
        caption
      }
      inlinePicture {
        picture
        caption
      }
      highlightedPicture {
        picture
        caption
      }
      quote
      embed
      paragraph {
        type
        text
        spans {
          start
          end
          type
          data {
            id
            uid
            type
            slug
            link_type
            url
          }
        }
      }
      textPicture {
        picture
        content {
          type
          text
          label
          spans {
            data {
              id
              uid
              type
              slug
              url
              link_type
            }
            start
            end
            type
          }
        }
      }
    }
    seo {
      title
      description
    }
    social {
      twitter {
        type
        title
        image
        handle
        description
      }
      generic {
        title
        image
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "readingTime",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstname",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastname",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v9 = [
  v0,
  v7,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "color",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "articles",
    "storageKey": "articles(first:7)",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 7,
        "type": "Int"
      }
    ],
    "concreteType": "Article",
    "plural": true,
    "selections": [
      v0,
      v1,
      v2,
      v3,
      v4,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "author",
        "storageKey": null,
        "args": null,
        "concreteType": "Author",
        "plural": false,
        "selections": [
          v5,
          v6
        ]
      }
    ]
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v12 = [
  v4,
  v2
],
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uid",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link_type",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v20 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "articles",
    "storageKey": "articles(first:10000)",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10000,
        "type": "Int"
      }
    ],
    "concreteType": "Article",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "publishedAt",
        "args": null,
        "storageKey": null
      },
      v0,
      v1,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "forceTitleToAppearUnderneath",
        "args": null,
        "storageKey": null
      },
      v2,
      v3,
      v4,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "widePicture",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "videoLink",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "author",
        "storageKey": null,
        "args": null,
        "concreteType": "Author",
        "plural": false,
        "selections": [
          v5,
          v6,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "biography",
            "args": null,
            "storageKey": null
          },
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebook",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitter",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagram",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "website",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sponsor",
        "storageKey": null,
        "args": null,
        "concreteType": "Partner",
        "plural": false,
        "selections": [
          v7,
          v8,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "logo",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "city",
        "storageKey": null,
        "args": null,
        "concreteType": "City",
        "plural": false,
        "selections": v9
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cities",
        "storageKey": null,
        "args": null,
        "concreteType": "City",
        "plural": true,
        "selections": v9
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": v9
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "slices",
        "storageKey": null,
        "args": null,
        "concreteType": "ArticleSlice",
        "plural": true,
        "selections": [
          v10,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "intro",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleIntro",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "initialLetter",
                "args": null,
                "storageKey": null
              },
              v11
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pictureDuo",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleInlinePicture",
            "plural": true,
            "selections": v12
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "inlinePicture",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleInlinePicture",
            "plural": false,
            "selections": v12
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "highlightedPicture",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleInlinePicture",
            "plural": false,
            "selections": v12
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quote",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "embed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "paragraph",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleText",
            "plural": true,
            "selections": [
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "spans",
                "storageKey": null,
                "args": null,
                "concreteType": "ArticleTextSpan",
                "plural": true,
                "selections": [
                  v13,
                  v14,
                  v10,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "data",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ArticleTextSpanData",
                    "plural": false,
                    "selections": [
                      v15,
                      v16,
                      v10,
                      v0,
                      v17,
                      v18
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "textPicture",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleTextPic",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "content",
                "storageKey": null,
                "args": null,
                "concreteType": "ArticleText",
                "plural": true,
                "selections": [
                  v10,
                  v11,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "spans",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ArticleTextSpan",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "data",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ArticleTextSpanData",
                        "plural": false,
                        "selections": [
                          v15,
                          v16,
                          v10,
                          v0,
                          v18,
                          v17
                        ]
                      },
                      v13,
                      v14,
                      v10
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "seo",
        "storageKey": null,
        "args": null,
        "concreteType": "SEO",
        "plural": false,
        "selections": [
          v1,
          v8
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "social",
        "storageKey": null,
        "args": null,
        "concreteType": "SocialMedia",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "twitter",
            "storageKey": null,
            "args": null,
            "concreteType": "TwtrSlices",
            "plural": true,
            "selections": [
              v10,
              v1,
              v19,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "handle",
                "args": null,
                "storageKey": null
              },
              v8
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "generic",
            "storageKey": null,
            "args": null,
            "concreteType": "GenSocialSlices",
            "plural": true,
            "selections": [
              v1,
              v19,
              v8
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcAmpArticleQuery",
  "id": null,
  "text": "query srcAmpArticleQuery {\n  articles(first: 10000) {\n    publishedAt\n    slug\n    title\n    forceTitleToAppearUnderneath\n    caption\n    readingTime\n    picture\n    widePicture\n    videoLink\n    author {\n      firstname\n      lastname\n      biography\n      picture\n      facebook\n      twitter\n      instagram\n      website\n    }\n    sponsor {\n      name\n      description\n      logo\n    }\n    city {\n      slug\n      name\n      color\n      articles(first: 7) {\n        slug\n        title\n        caption\n        readingTime\n        picture\n        author {\n          firstname\n          lastname\n        }\n      }\n    }\n    cities {\n      slug\n      name\n      color\n      articles(first: 7) {\n        slug\n        title\n        caption\n        readingTime\n        picture\n        author {\n          firstname\n          lastname\n        }\n      }\n    }\n    category {\n      slug\n      name\n      color\n      articles(first: 7) {\n        slug\n        title\n        caption\n        readingTime\n        picture\n        author {\n          firstname\n          lastname\n        }\n      }\n    }\n    slices {\n      type\n      intro {\n        initialLetter\n        text\n      }\n      pictureDuo {\n        picture\n        caption\n      }\n      inlinePicture {\n        picture\n        caption\n      }\n      highlightedPicture {\n        picture\n        caption\n      }\n      quote\n      embed\n      paragraph {\n        type\n        text\n        spans {\n          start\n          end\n          type\n          data {\n            id\n            uid\n            type\n            slug\n            link_type\n            url\n          }\n        }\n      }\n      textPicture {\n        picture\n        content {\n          type\n          text\n          label\n          spans {\n            data {\n              id\n              uid\n              type\n              slug\n              url\n              link_type\n            }\n            start\n            end\n            type\n          }\n        }\n      }\n    }\n    seo {\n      title\n      description\n    }\n    social {\n      twitter {\n        type\n        title\n        image\n        handle\n        description\n      }\n      generic {\n        title\n        image\n        description\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcAmpArticleQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v20
  },
  "operation": {
    "kind": "Operation",
    "name": "srcAmpArticleQuery",
    "argumentDefinitions": [],
    "selections": v20
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ebe6da5fd6d20e4a2df163e128fd6576';
module.exports = node;
